// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "components/" + {1918: "core/media.mixins",3760: "core/media.providers",4702: "core/media.tracker",5949: "hpe-wc/ibm-video-player",}[chunkId] + ".9b47191f88cc.js"
}